let _ = require('lodash');
let computed = require('baobab').monkey;
let SCHEME = require('../../../helpers/scheme');

function isContinueEnabled (error, form, isDisabled, extraRequiredFields) {
    let requiredFields = ['firstName', 'lastName', 'countryId', 'legalAddress'];
    if (extraRequiredFields) {
        requiredFields = requiredFields.concat(extraRequiredFields);
    }
    if (form && form.userType === 2) {
        requiredFields = _.concat(requiredFields, ['organization']);
        switch (form.countryId) {
            case 1:
                requiredFields = _.concat(requiredFields, ['inn10', 'kpp']);
                break;
            case 4:
                requiredFields = _.concat(requiredFields, ['bin']);
                break;
            default:
                break;
        }
    } else if (form && form.userType === 3) {
        requiredFields = _.concat(requiredFields, ['organization', 'inn12']);
    }
    let requiredError = _.clone(error, false);
    if (requiredError && form && form.userType === 1) {
        delete requiredError['organization'];
        delete requiredError['inn10'];
        delete requiredError['inn12'];
        delete requiredError['bin'];
        delete requiredError['kpp'];
    }
    let requiredKeys = _.keys(_.omitBy(form, (key) => !key));
    let differenceLength = _.difference(requiredFields, requiredKeys).length;

    return _.every([_.isEmpty(requiredError), !differenceLength, !isDisabled]);
}

module.exports = {
    isContinueEnabled,

    /**
     * Проверяем на то что все обязательные поля заполненны и валидны
     * @param {Object} state
     */
    registerButton (state) {
        state.set(['registration', 'computed', 'registerButton', 'isEnabled'], computed(
            ['registration', 'error'],
            ['registration', 'computed', 'error', 'repeatPassword'],
            ['registration', 'form'],
            ['registration', 'ui', 'registerButton', 'isDisabled'],
            (error, repeatPassword, form, isDisabled) => {
                if (repeatPassword) {
                    return false;
                }
                return isContinueEnabled(error, form, isDisabled, ['email', 'password', 'repeatPassword'])
            }
        ));
    },

    setRepeatPasswordError (state) {
        state.set(['registration', 'computed', 'error', 'repeatPassword'], computed(
            ['registration', 'error', 'repeatPassword'],
            ['registration', 'form', 'repeatPassword'],
            ['registration', 'form', 'password'],
            (errorRepeatPassword, repeatPassword, password) => {
                if (!repeatPassword) {
                    return;
                }

                if (errorRepeatPassword) {
                    return errorRepeatPassword;
                }

                if (repeatPassword !== password) {
                    return _.get(SCHEME.repeatPassword, 'properties.value.messages.repeat');
                }
            }
        ));
    },

    /**
     * Есть возможность выбрать тип пользователя (физ.лицо, юр.лицо и т.д.)
     * Сейчас юр.лица могут быть только для России и Казахстана
     * @param {Object} state
     */
    isUserTypeSelectEnabled (state) {
        state.set(['registration', 'computed', 'isUserTypeSelectEnabled'], computed(
            ['registration', 'form', 'countryId'],
            (countryId) => countryId === 1 || countryId === 4
        ));
    }
};



// WEBPACK FOOTER //
// ./actions/computed/auth/registration.js